import React, { Component } from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import { hasShapeSupport } from '../../../helpers/serverRenderingUtils';
import {
  item,
  itemWithShapes,
  clipLeft,
  clipRight,
  textMaskLeft,
  textMaskRight,
  firstTextMaskLeft,
  firstTextMaskRight,
  lastTextMaskLeft,
  lastTextMaskRight,
  finishShapeRightBottom,
  finishShapeRightTop,
  finishShapeLeftBottom,
  finishShapeLeftTop,
} from './styles.sass';

const maskClasses = {
  left: textMaskLeft,
  right: textMaskRight,
};
const firstMaskClasses = {
  left: firstTextMaskLeft,
  right: firstTextMaskRight,
};
const lastMaskClasses = {
  left: lastTextMaskLeft,
  right: lastTextMaskRight,
};

class MarketingCallout extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      hasShapeSupport: false,
    };
  }

  componentDidMount() {
    this.setState({
      hasShapeSupport: hasShapeSupport(),
    });
  }

  render() {
    const {
      direction = 'left',
      height = 200,
      children,
      bgColor = '#292F36',
      nextBgColor = '#292F36',
      prevBgColor = '#292F36',
      isFirst = false,
      isLast = false,
    } = this.props;
    const isLeft = direction === 'left';
    if (!this.state.hasShapeSupport) {
      return (
        <div
          className={`${item} ${isLeft ? 'text-left' : 'text-right'}`}
          style={{
            backgroundColor: bgColor,
          }}
        >
          <Grid>
            <Row>
              <Col lg={6} lgOffset={isLeft ? 0 : 6}>
                {children}
              </Col>
            </Row>
          </Grid>
        </div>
      );
    }
    return (
      <div
        className={`${item} ${itemWithShapes} ${isLeft ? clipLeft : clipRight}`}
        style={{
          minHeight: height,
          backgroundColor: bgColor,
        }}
      >
        {!isLeft && (
          <div
            className={finishShapeRightTop}
            style={{ backgroundColor: prevBgColor }}
          />
        )}
        {!isLeft && (
          <div
            className={finishShapeRightBottom}
            style={{ backgroundColor: nextBgColor }}
          />
        )}
        {isLeft && (
          <div
            className={finishShapeLeftTop}
            style={{ backgroundColor: prevBgColor }}
          />
        )}
        {isLeft && (
          <div
            className={finishShapeLeftBottom}
            style={{ backgroundColor: nextBgColor }}
          />
        )}
        <div
          className={getMaskClass(direction, isFirst, isLast)}
          style={{
            minHeight: height,
            backgroundColor: nextBgColor,
          }}
        />
        {children}
      </div>
    );
  }
}

function getMaskClass(direction, isFirst = false, isLast = false) {
  if (isFirst) {
    return firstMaskClasses[direction];
  }
  if (isLast) {
    return lastMaskClasses[direction];
  }
  return maskClasses[direction];
}

export default MarketingCallout;
